import React from 'react';
import { withTranslation } from 'react-i18next';
import { Card, Row, Col, Tag, Divider, List, Icon } from 'antd';
import { get } from 'lodash';
import {
    ClockCircleOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';

class LatestTasks extends React.Component {
    state = ({

    });


    tagPriority = (priority) => {
        let color = '';
        if (priority === 'High') {
            color = 'volcano';
        } else if (priority === 'Medium') {
            color = 'geekblue'
        } else {
            color = 'green'
        }
        return (
            <Tag style={{ marginRight: '0px' }} color={color}>
                {priority.toUpperCase()}
            </Tag>
        );
    }

    render() {
        const { tasksLatest, t, hiddenLead } = this.props;

        return (
            <div>
                {!hiddenLead && <p className='pStyle' style={{ textAlign: 'center' }}>{t('dashboard.latest_tasks.latest_tasks', "Latest tasks")}</p>}
                <List
                    itemLayout="horizontal"
                    dataSource={tasksLatest}
                    renderItem={task => (
                        <List.Item>
                            <List.Item.Meta
                                title={
                                    <React.Fragment>
                                        {task.title}<Divider type="vertical" />
                                        {task.priority_display ? <React.Fragment>{this.tagPriority(task.priority_display)}<Divider type="vertical" /></React.Fragment> : ''}
                                        {task.due_date ? <React.Fragment><Tag style={{ marginRight: '0px' }}><ClockCircleOutlined /> {task.due_date}</Tag><Divider type="vertical" /></React.Fragment> : ''}
                                        {task.status_display ? <React.Fragment><Tag style={{ marginRight: '0px' }}><ExclamationCircleOutlined /> {task.status_display}</Tag></React.Fragment> : ''}
                                        {get(task, ['lead', 'name']) && !hiddenLead &&
                                            <React.Fragment>
                                                <Divider type="vertical" />
                                                <Tag color="#f50" style={{ marginRight: '0px' }}>
                                                    <Icon type="usergroup-add" /> {get(task, ['lead', 'name'])}
                                                </Tag>
                                            </React.Fragment>}
                                    </React.Fragment>
                                }
                                description={task.description}
                            />
                        </List.Item>
                    )
                    }
                />
            </div >
        );
    }
}

export default withTranslation()(LatestTasks);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/LatestTasks.js